import React from 'react';

import {BaseSeedDataConfig, SeedDataConfigType} from 'analysis-tool/create-analysis-modal/SeedDataTypes';
import {assert} from 'Asserts';
import {MultiStudyAnalysisDetails} from 'studies/typed/shared/MultiStudyAnalysisDetails';

import {SingleStudyAnalysisDetails} from './SingleStudyAnalysisDetails';

export type StudySeedDataConfig = BaseSeedDataConfig<
  SeedDataConfigType.STUDY,
  {
    studyIds: Array<string>;
  }
>;

export function validateStudySeedDataConfigValid(config: StudySeedDataConfig): boolean {
  return config.data.studyIds.length > 0;
}

export function StudySeedDataConfigEditor(props: {
  value: StudySeedDataConfig;
  onChange: (value: StudySeedDataConfig) => void;
}): JSX.Element {
  const studyIds = props.value.data.studyIds;
  assert(studyIds.length > 0, 'Expected at least one study ID to be selected');
  return studyIds.length === 1 ? (
    <SingleStudyAnalysisDetails studyId={studyIds[0]} />
  ) : (
    <MultiStudyAnalysisDetails studyIds={studyIds} />
  );
}
